import React from 'react';
import Button from "react-bootstrap/Button";
import {useHistory} from "react-router-dom";
import {reloadOrRedirect} from '../../../utils/location-utils';

/**
 * Shortcut button for opening the schema create page.
 */
export default function CreateSchemaAction(props: { forbidden?: boolean }) {
  const history = useHistory();
  const pageUrl = '/schema/create';
  const title = props.forbidden ? 'Create schema is forbidden' : 'Create schema';
  return (
    <Button onClick={() => reloadOrRedirect(history, pageUrl, pageUrl)}
            className="create-schema-button btn btn-primary"
            disabled={props.forbidden}
            title={title}>
      Create Schema
    </Button>
  );
}
